export default [
  {
    path: '/loginExpert/selectApplyIndex',
    name: 'selectApplyIndex',
    component: () => import('@/epp/expertmain/selectexpertapply/SelectLoginExpertApplyIndex'),
    meta: { title: '项目抽取记录' },
    hidden: true
  },

]
